/**
 * Multiple choice helpers, shared by the editor, the host panel, the
 * projector and the phones. The server rules live in
 * Cerebrex/utils/multipleChoice.js.
 *
 * A question with 2 to 6 choices is multiple choice. correctChoice is the
 * 0-based index of the correct choice. It is secret until the reveal.
 */
export const CHOICE_LETTERS = ['A', 'B', 'C', 'D', 'E', 'F'] as const;
export const MIN_CHOICES = 2;
export const MAX_CHOICES = 6;

export function choiceLetter(index: number): string {
  return CHOICE_LETTERS[index] ?? '?';
}

export function isMultipleChoice(q: { choices?: readonly string[] | null } | null | undefined): boolean {
  return Array.isArray(q?.choices) && q!.choices!.length >= MIN_CHOICES;
}

/** "B" -> 1. Anything else -> null. */
export function letterToIndex(raw: string | null | undefined): number | null {
  if (!raw) return null;
  const i = (CHOICE_LETTERS as readonly string[]).indexOf(raw.trim().toUpperCase());
  return i === -1 ? null : i;
}

/**
 * Number of columns for the projector choices grid. Two columns for up to
 * four short choices, three for five or six short choices, and one column
 * when a choice is long enough to wrap badly in a narrow column.
 */
export function choiceColumns(choices: readonly string[]): 1 | 2 | 3 {
  const longest = choices.reduce((n, c) => Math.max(n, c.length), 0);
  if (longest > 60) return 1;
  if (choices.length >= 5 && longest <= 28) return 3;
  return 2;
}
